import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const KEY = "yuo_theme";
const EVT = "yuo-theme";

export const getTheme = () =>
  typeof document !== "undefined" && document.body.classList.contains("day") ? "day" : "night";

export function applyTheme(theme, { persist = true, animate = true } = {}) {
  const body = document.body;
  if (animate) {
    body.classList.add("theme-switching");
    setTimeout(() => body.classList.remove("theme-switching"), 350);
  }
  body.classList.toggle("day", theme === "day");
  try { localStorage.setItem(KEY, theme); } catch {}
  window.dispatchEvent(new Event(EVT));
  if (persist) api.setTheme(theme).catch(() => {});
}

export function useTheme() {
  const [theme, setTheme] = useState(getTheme);
  useEffect(() => {
    const h = () => setTheme(getTheme());
    window.addEventListener(EVT, h);
    return () => window.removeEventListener(EVT, h);
  }, []);
  const toggle = () => applyTheme(theme === "day" ? "night" : "day");
  return [theme, toggle];
}
